import React from "react";
import { SectionContainerLight } from "../common/sections/SectionContainerLight";

export const SectionChooseProgram: React.FC = () => {
  const cards = [
    {
      title: "LMS: Sekolah, Universitas, Perusahaan",
      description:
        "Platform digital untuk mengelola dan memantau proses pembelajaran atau pelatihan secara online",
      image: "/img/program-intro.png",
      bgColor: "bg-orange-500",
      hexColor: "#f97316",
      price: "Rp 1.500.000",
      corners:
        "rounded-[20px] md:rounded-tl-[100px] md:rounded-tr-[10px] md:rounded-bl-[10px] md:rounded-br-[10px]",
      link: "/lms",
    },
    {
      title: "Ekstrakurikuler Sekolah : SD, SMP, SMA",
      description:
        "Ekskul seru dan edukatif terhadap AI, robotik, coding, wirausaha, dan digital marketing",
      image: "/img/program-workshop.png",
      bgColor: "bg-teal-600",
      hexColor: "#0d9488",
      price: "Rp 200.000",
      corners:
        "rounded-[20px] md:rounded-tl-[10px] md:rounded-tr-[100px] md:rounded-bl-[10px] md:rounded-br-[10px]",
      link: "/ekskul",
    },
    {
      title: "Bootcamp Terakreditasi Kemnaker : Umum",
      description:
        "Pelatihan & sertifikasi keahlian Fullstack Developer",
      image: "/img/program-bootcamp.png",
      bgColor: "bg-pink-500",
      hexColor: "#ec4899",
      price: "Rp 8.550.000",
      corners:
        "rounded-[20px] md:rounded-tl-[10px] md:rounded-tr-[10px] md:rounded-bl-[100px] md:rounded-br-[10px]",
      link: "/program/bootcamp",
    },
    {
      title: "Pelatihan Perusahaan & Sertifikasi BNSP",
      description:
        "Pelatihan AI dengan sertifikasi resmi dari BNSP yang kredibel untuk dunia kerja",
      image: "/img/program-ekstra.png",
      bgColor: "bg-purple-600",
      hexColor: "#9333ea",
      // price: "Rp 2.400.000",
      corners:
        "rounded-[20px] md:rounded-tl-[10px] md:rounded-tr-[10px] md:rounded-bl-[10px] md:rounded-br-[100px]",
      link: "/program/bnsp",
    },
  ];

  return (
    <SectionContainerLight
      id="program-type"
      additionalClassName="bg-white !py-4 !mt-2 md:-mb-20 -mb-12"
    >
      <div className="container mx-auto px-4 -mt-8">
        <div className="flex flex-col mx-auto text-center items-center mb-4 md:mb-8">
          <p className="text-black text-2xl md:text-4xl font-body font-semibold mt-10">
            Pilih Program Belajarmu
          </p>
          <div className="border-2 md:border-4 border-accent-100 rounded-full w-40 mt-4 md:mt-6" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
          {cards.map(
            (
              { title, description, image, bgColor, hexColor, corners, link, price },
              idx
            ) => (
              <div key={idx} className="relative group overflow-visible">
                <div
                  className="
                    absolute -top-7 md:-right-7 -right-2 z-30
                  "
                >
                  {title !== "Pelatihan Perusahaan & Sertifikasi BNSP" &&
                    <div className="relative bg-red-600 text-white md:px-4 md:py-2 px-3 py-1  rounded-md shadow-xl">
                      <p className="text-sm font-semibold">Start from</p>
                      <p className="text-lg font-bold">{price}</p>
                    </div>
                  }
                </div>

                {/* CARD */}
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`relative group flex md:h-[220px] md:group-hover:h-[230px] overflow-hidden ${corners} h-[160px] group-hover:h-[210px] transition-all duration-500`}
                >
                  {/* IMAGE */}
                  <div className="relative flex-[2] md:flex-1 h-full overflow-hidden">
                    <img
                      src={image}
                      alt={title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div
                      className="absolute inset-0 pointer-events-none"
                      style={{
                        background: `linear-gradient(to left, ${hexColor}, transparent)`,
                      }}
                    />
                  </div>

                  {/* CONTENT */}
                  <div
                    className={`flex-[3] md:flex-1 h-full ${bgColor} relative overflow-hidden`}
                  >
                    <h3
                      className="
                        absolute left-4 right-4 top-1/2
                        -translate-y-1/2
                        text-white font-bold whitespace-pre-line
                        transition-all duration-500
                        md:group-hover:top-[30%]
                        group-hover:top-[35%]
                      "
                      style={{ fontSize: "clamp(1.25rem, 2.5vw, 1.5rem)" }}
                    >
                      {title}
                    </h3>

                    <p
                      className={`
                        absolute left-4 right-4 top-1/2
                        opacity-0 text-white
                        transition-all duration-500
                        group-hover:opacity-100
                        md:group-hover:top-[48%]
                        group-hover:top-[50%]
                        mt-5 md:mt-0
                      `}
                      style={{ fontSize: "clamp(0.75rem, 2vw, 1.125rem)" }}
                    >
                      {description}
                    </p>
                  </div>
                </a>
              </div>
            )
          )}
        </div>
      </div>
    </SectionContainerLight>
  );
};
